import React, {useEffect, useState} from "react"
import httpClient from "../../../services/httpClient";
import {teachersApi} from "../../../constans/apiUrls";
import useQuery from "../../../hook/useQuery";
import useToastNotify from "../../../hook/useToastNotify";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import {badgeType, TeacherAttachmentType} from "../../../constans/enumTypes";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import {FiEdit} from "react-icons/fi";
import Table from "../../Elements/Table";
import TableEmpty from "../../Elements/Table/TableEmpty";
import {
    generateImageLink, generateMediaLink,
    generateTeacherAttachmentTitle,
    isNotEmpty
} from "../../../helpers/functions";
import PageHeader from "../../Elements/PageHeader";
import MyModal from "../../Elements/MyModal";
import {useLocation} from "react-router-dom";
import {IRouterListToData} from "../../../contracts/data/router";
import {ITeacherAttachmentData} from "../../../contracts/data/teacher";
import {MdOutlineLoop} from "react-icons/md";
import Badge from "../../Elements/Badge";
import TeacherAttachmentForm from "../../../forms/dashboard/teacher/TeacherAttachmentForm";


const TeacherAttachments: React.FC = () => {
    const {toastNotify} = useToastNotify()
    const queryParams = useQuery()
    const [data, setData] = useState<Array<ITeacherAttachmentData>>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false)
    const [typeModal, setTypeModal] = useState<string>('create')
    const [selectItem, setSelectItem] = useState<ITeacherAttachmentData>({
        id: 0,
        teacher: 0,
        type: TeacherAttachmentType.FILE,
        attachment: '',
        attachment_url: '',
        is_active: false
    });
    const location = useLocation<IRouterListToData>()

    const titleHeadTable: Array<string> = ['#', 'نوع', 'مشاهده', 'وضعیت', 'عملیات']

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${teachersApi.attachment_list}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200) {
                    setData(response?.data)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const handleChangeStatusItem = async (id: number, index: number) => {
        await httpClient().put(teachersApi.attachment_status, {teacher_attachment: id})
            .then(response => {
                if(response.status === 200){
                    data[index].is_active = !data[index].is_active
                    setReload(true)
                }
            })
            .catch(error => {console.log(error)})
    }

    const handlerCreateOrUpdateBtn = (newData: ITeacherAttachmentData) => {
        if (typeModal === 'create') {
            setData([
                ...data, newData
            ])
        } else {
            data.map((item, index) => {
                if (item.id === newData.id) {
                    data[index] = newData
                }
            })
        }
        setSelectItem({
            id: 0,
            teacher: 0,
            type: TeacherAttachmentType.FILE,
            attachment: '',
            attachment_url: '',
            is_active: false
        })
        setShowModal(false)
        setReload(true)

    }

    useEffect(() => {
        fetchItemsData()
    }, [])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={generateTeacherAttachmentTitle(item?.type)}/></TableTd>
            <TableTd>
                <a className={"text-blue-500 underline"} href={item?.type === TeacherAttachmentType.IMAGE ? generateImageLink(item?.attachment_url) : generateMediaLink(item?.attachment_url)} target={"_blank"}>مشاهده فایل</a>
            </TableTd>
            <TableTd>
                <Badge title={item?.is_active ? "فعال" : "غیرفعال"}
                       typeBadge={item?.is_active ? badgeType.success : badgeType.error}/>
            </TableTd>
            <TableTd>
                <MenuDrop>
                    <MenuDropItem title={"ویرایش"} icon={<FiEdit/>}
                                  handleOnSubmit={() => {
                                      setTypeModal('edit')
                                      setSelectItem(item)
                                      setShowModal(true)
                                  }}/>
                    <MenuDropItem title={"تغییر وضعیت"} icon={<MdOutlineLoop/>}
                                  handleOnSubmit={() => handleChangeStatusItem(item?.id, index)}/>
                </MenuDrop>
            </TableTd>
        </TableTr>
    )

    return (
        <React.Fragment>
            <PageHeader
                title={`اطلاعات پیوست شده "${isNotEmpty(queryParams.get('name')) ? queryParams.get('name') : ''}"`}
                isBackBtn urlBackBtn={`${location?.state?.page}?page_num=${location?.state?.page_num}`}
                isFirstBtn={true} firstBtnTitle={'اطلاعات جدید'} handlerFirstBtn={() => {
                setShowModal(true)
                setTypeModal('create')
                setSelectItem({
                    id: 0,
                    teacher: 0,
                    type: TeacherAttachmentType.FILE,
                    attachment: '',
                    attachment_url: '',
                    is_active: false
                })
            }}/>
            <MyModal title={`${typeModal === 'create' ? "ثبت" : "ویرایش"} اطلاعات`} isOpen={showModal} handlerSecondaryButton={() => {
                setShowModal(false)
                setSelectItem({
                    id: 0,
                    teacher: 0,
                    type: TeacherAttachmentType.FILE,
                    attachment: '',
                    attachment_url: '',
                    is_active: false
                })
            }} btnSecondaryTxt={"بیخیال!"}>
                <TeacherAttachmentForm formType={typeModal} prevData={selectItem}
                                   teacherId={parseInt(queryParams.get('id')!)}
                                   handleChange={(data: ITeacherAttachmentData) => handlerCreateOrUpdateBtn(data)}/>
            </MyModal>
            <Table isLoading={loading} titlesTable={titleHeadTable} isSearch={false}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"لیست اطلاعاتی یافت نشد"}/>}
            </Table>
        </React.Fragment>
    )
}

export default TeacherAttachments